import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
// //Import Scrollbar
import SimpleBar from "simplebar-react";
// MetisMenu
import withRouter from "components/Common/withRouter";
//i18n
import { withTranslation } from "react-i18next";
import { adminRoutes } from "../../routes/admin";
import { adminOperationsRoutes } from "../../routes/admin_operations";
import { fiancierRoutes } from "../../routes/finacier";
import { fiancierOpRoutes } from "../../routes/financier_operation";
import { PERMISSION } from "common/permission";
import { decryptedValue, getPermission, getUser, uId } from "common/utility";
import { customerRoutes } from "routes/customer";
import { partnerRoutes } from "routes/partner";
import { commonRoutes } from "routes/common_routes";


const SidebarContent = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return true;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (const element of items) {
      let item = element;
      const parent = element.parentElement;

      if (item?.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes?.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (const element of items) {
      if (pathName === element.pathname) {
        matchingMenuItem = element;
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    ref.current.recalculate();
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    const rolesPermission = await getPermission();
    const user = decryptedValue(localStorage.getItem("user"));
    const roleName = user.roleName    
    let rouList = []
     if(roleName == "fundLync_cutomer"){
      rouList = customerRoutes
    } else 
    if (roleName == 'financier_admin') {
      rouList = fiancierRoutes
    }else if (roleName == 'financier_operations') {
      rouList = fiancierOpRoutes
    }
    else {
      rouList = commonRoutes(roleName)
    }
    const allRouters = Object.assign([...rouList]);
    const cloneRouter = allRouters.map((r) => {
      if (r.submenu?.length > 0) {
        return { ...r, submenu: [...r.submenu] };
      } else return { ...r };
    });
    const allRoutes = chechMenuPermission(rolesPermission, cloneRouter);
    setRoutes(allRoutes);
  };

  const chechMenuPermission = (rolesPermission, routerList) => {
    return (
      routerList
        .filter((r) => !r.hideMenu)
        .filter((route) => {
          let isPagePermission = false;
          if (route.submenu?.length > 0) {
            const submenu = chechMenuPermission(rolesPermission, route.submenu);
            route.submenu = submenu;
            isPagePermission = submenu?.length > 0;
          } else {
            const { permission, action } = route;
            isPagePermission = isMenuPermissionExist(
              rolesPermission,
              permission,
              action
            );
          }
          return isPagePermission;
        }) || []
    );
  };

  const isMenuPermissionExist = (rolesPermission, permission, action) => {
    const pagePermission = rolesPermission.find(
      (p) => p.permission_name === permission
    );
    return (
      pagePermission &&
      (pagePermission[action] == PERMISSION.PERMISSION_STATUS.ALLOWED ||
        pagePermission[action] ===
        PERMISSION.PERMISSION_STATUS.SOME_OTHER_STATUS)
    );
  };

  useEffect(() => {
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  const menuListWithIcon = (nav, index) => {
    return (
      <li key={index}>
        <Link to={nav.path}>
          <i className={nav.icon}></i>
          <span>{props.t(nav.displayName)}</span>
        </Link>
      </li>
    );
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div
          id="sidebar-menu"
          className="h-100"
          style={{ position: "relative" }}
        >
          <ul className="metismenu list-unstyled" id="side-menu">
            {routes.map(
              (nav, i) =>
                !nav.hideMenu &&
                (!Object.hasOwn(nav, "submenu") ? (
                  menuListWithIcon(nav, `__parentmanu__${i}`)
                ) : (
                  <li key={"__parentnestedmenu__" + uId()} >
                    <a className="has-arrow">
                      <i className={nav.icon}></i>
                      <span>{props.t(nav.displayName)}</span>
                    </a>
                      <ul className="sub-menu vertical-scroll" style={{
                        maxHeight: "250px",  
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}>
                      {nav.submenu.map((subnav, j) => (
                        <li key={"__nestedmenu__" + uId()}>
                          <Link to={subnav.path}>
                            {props.t(subnav.displayName)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
